import React from 'react';

export default function AdminHeader({ title, subtitle }) {
  if (!title && !subtitle) return null;
  return (
    <div className="admin-page-header">
      {title && <h1 className="admin-page-title">{title}</h1>}
      {/* {subtitle && <p className="admin-page-subtitle">{subtitle}</p>} */}
    </div>
  );
}

